import viewMessageTemplate from "./view_message.html";
import en from "./en.translation.json";
import es from "./es.translation.json";

export default {
    bindings: {
        announcement: "<",
        translated: "<",
        farm: "<",
        attachments: "<",
    },
    template: viewMessageTemplate,
    name: "viewMessage",
    translations: { en, es },
};
